import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST_EVALUATION_PURPOSE: 'LIST_EVALUATION_PURPOSE',
};

export const listEvaluationPurpose = () => ({
  type: ACTION.LIST_EVALUATION_PURPOSE,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_REF_EVALUATION_PURPOSE,
  })
    .then(response => {
      const data = response.data;
      return Array.isArray(data)
        ? data
        : (data && Array.isArray(data.results) ? data.results : []);
    })
    .catch(err => Promise.reject((err.response && err.response.data) || err.message)),
});







// WEBPACK FOOTER //
// ./src/redux/references/evaluation_purpose_actions.js